import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Get this from your Firebase project settings console
const firebaseConfig = {
  apiKey: "AIzaSyB8ahwEl03uUgCKFtTmdu42EQtpHh9uMoA",
  authDomain: "summer-advent-calendar.firebaseapp.com",
  projectId: "summer-advent-calendar",
  storageBucket: "summer-advent-calendar.firebasestorage.app",
  messagingSenderId: "627638768744",
  appId: "1:627638768744:web:90d71a86e49c5018d7d7dd"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

